module.exports = __webpack_public_path__ + "img/txt.3591a94d.png";